import { useState } from 'react';
import { stopwatch } from '@abyss/ui/tools/stopwatch';

const DEFAULT_ERROR = `The system is unable to respond at the moment. \
  Please try refreshing the page (click on REFRESH at the top of the page \
  or press F5) or try again at a later time.`;

const stringify = obj => {
  if (obj) {
    const str = [];
    Object.keys(obj).forEach(key => {
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    });
    return str.join('&');
  }
  return '';
};

const fetchREST = options => {
  let { url } = options;
  let body;

  if (options.method === 'GET' && options.variables) {
    url = `${url}?${stringify(options.variables)}`;
  }

  if (options.method === 'POST' && options.variables) {
    if (
      options.headers &&
      options.headers['Content-Type'] === 'application/x-www-form-urlencoded'
    ) {
      body =
        options.variables instanceof URLSearchParams
          ? options.variables.toString()
          : stringify(options.variables);
    } else {
      body = options.variables;
    }
  }

  if (options.isStringify && options.variables) {
    body = JSON.stringify(options.variables);
  }

  const timer = stopwatch.start();
  return fetch(url, {
    method: options.method,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(options.headers || {}),
    },
    body,
    credentials: 'include',
  }).then(response => {
    if (!response.ok) {
      return response.json().then(error => {
        throw { ...error, status: response.status };
      });
    }

    return response.json().then(json => {
      return {
        status: response.status,
        duration: timer.stop(),
        body: json,
      };
    });
  });
};

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export const useQuery = (url, queryOptions) => {
  const [queryResult, setQueryResult] = useState(initialState);

  const queryAction = actionParams => {
    setQueryResult({
      ...initialState,
      loading: true,
    });

    return fetchREST({
      method: queryOptions.method || 'POST',
      variables: actionParams && actionParams.variables,
      url,
      isStringify: queryOptions.isStringify || false,
      headers: queryOptions.headers || {},
    })
      .then(response => {
        if (queryOptions && queryOptions.onCompleted) {
          queryOptions.onCompleted(response);
        }

        setQueryResult({
          ...initialState,
          data: response.body.data || response.body,
        });

        return response;
      })
      .catch(error => {
        if (queryOptions && queryOptions.onError) {
          queryOptions.onError({ ...error, message: DEFAULT_ERROR });
        }

        setQueryResult({
          ...initialState,
          error: { ...error, message: DEFAULT_ERROR },
        });

        throw error;
      });
  };

  return [queryResult, queryAction];
};
